module.exports = __webpack_public_path__ + "img/img1.9d3efb18.png";